import * as ItemRepairActionType from './constants';
import * as CommonActionType from 'Common/constants';
import * as TradeActionType from 'Trades/constants';

const defaultParams = {
  searchKey: '',
  searchField: 'description',
  skip: 1,
  take: 10,
  sort: { field: 'tradeName', order: 'ascending' },
  status: 'all',
  totalRecord: 0,
  totalPage: 0
};

const ManageItemRepair = {
  items: [],
  params: defaultParams
};

const ItemRepairProfile = {
  id: '',
  tradeId: '',
  tradeName: '',
  description: '',
  problemCount: 0,
  isActive: true
};

const ManageProblem = {
  items: [],
  params: {
    searchKey: '',
    searchField: 'name',
    skip: 1,
    take: 1000,
    sort: { field: 'name', order: 'ascending' },
    status: 'all',
    totalRecord: 0,
    totalPage: 0
  }
};

const ProblemProfile = {
  id: '',
  name: '',
  itemRepairId: '',
  itemRepairName: '',
  isActive: true
};

const ItemRepairState = {
  ManageItemRepair: ManageItemRepair,
  ItemRepairProfile: ItemRepairProfile,
  ErrorMsg: [],
  IsOpenFormAddEdit: false,
  Title: 'New item',
  IsCreate: true,
  SelectListItemTrades: [],
  SelectListItem: [],
  ManageProblem: ManageProblem,
  ProblemProfile: ProblemProfile,
  dateTime: new Date(),
  ItemRepairList: [],
  ProblemList: [],
  BlueTapeProblemList:[]
};

export default function TradeStore(state = ItemRepairState, action) {
  switch (action.type) {
    case CommonActionType.COMMON_SELECT_LIST_ITEM_TO_REPAIR_SUCCESS:
      return processSelectListItems(state, action);
    case ItemRepairActionType.SEARCH_PROBLEM_SUCCESS:
      return processSearchProblem(state, action);
    case ItemRepairActionType.SEARCH_ITEM_REPAIR_SUCCESS:
      return processSearchSuccess(state, action);
    case ItemRepairActionType.OPEN_FORM_CREATE_ITEM_REPAIR:
      return {
        ...state,
        ItemRepairProfile: ItemRepairProfile,
        Title: 'New item',
        IsCreate: true,
        IsOpenFormAddEdit: true,
        ErrorMsg: [],
        dateTime: new Date()
      };
    case ItemRepairActionType.OPEN_FORM_CREATE_PROBLEM:
      return {
        ...state,
        ProblemProfile: ProblemProfile,
        Title: 'New problem',
        IsCreate: true,
        // IsOpenFormAddEdit: true,
        ErrorMsg: [],
        dateTime: new Date()
      };
    case ItemRepairActionType.CLOSE_FORM_CREATE_PROBLEM:
      return {
        ...state,
        IsOpenFormAddEdit: false,
        ErrorMsg: []
      };
    case ItemRepairActionType.CREATE_ITEM_REPAIR_ASYNC:
    case ItemRepairActionType.UPDATE_ITEM_REPAIR_ASYNC:
    case ItemRepairActionType.CREATE_PROBLEM_ASYNC:
    case ItemRepairActionType.UPDATE_PROBLEM_ASYNC:
      return {
        ...state,
        ErrorMsg: []
      };
    case ItemRepairActionType.GET_ITEM_REPAIR_BY_ID_SUCCESS:
      return processGetItemByIdSuccess(state, action);
    case ItemRepairActionType.GET_PROBLEM_BY_ID_SUCCESS:
      return processGetProblemByIdSuccess(state, action);
    case CommonActionType.COMMON_SELECT_LIST_ITEM_TRADE_SUCCESS:
      return processSelectListItemTrade(state, action);
    case ItemRepairActionType.ADD_EDIT_ITEM_REPAIR_ERROR:
      return processAddEditItemError(state, action);
    case ItemRepairActionType.RESET_ITEM_REPAIR:
      return {
        ...state,
        ManageItemRepair: ManageItemRepair
      };
    case ItemRepairActionType.SELECT_LIST_ITEM_REPAIR_SUCCESS:
      return processSelectListItemRepairSuccess(state, action);
    case ItemRepairActionType.SELECT_LIST_PROBLEM_SUCCESS:
      return processSelectListProblemSuccess(state, action);
    case ItemRepairActionType.SELECT_LIST_BLUE_TAPE_PROBLEM_SUCCESS:
      return {
        ...state,
        BlueTapeProblemList: action.data
      };
    case ItemRepairActionType.GET_PROBLEM_BY_ID_ASYNC:
      return {
        ...state,
        ErrorMsg: []
      };
    case TradeActionType.SELECT_LIST_TRADE_SUCCESS:
      return {
        ...state,
        SelectListItemTrades: action.data
      };
    case ItemRepairActionType.RESET_PROBLEM:
      return {
        ...state,
        ManageProblem: ManageProblem
      };
    default:
      return state;
  }
}

const processSearchSuccess = (state, action) => {
  var result = action.data;

  var manageItem = {
    items: result.data.items,
    params: {
      totalRecord: result.data.totalRecord,
      totalPage: result.data.totalPage,
      skip: result.params.skip + 1,
      take: result.params.take,
      status: result.params.status,
      name: result.params.name,
      sort: { field: result.params.sortField, order: result.params.sortOrder }
    }
  };
  return {
    ...state,
    ManageItemRepair: manageItem,
    ErrorMsg: [],
    IsOpenFormAddEdit: false
  };
};

const processGetItemByIdSuccess = (state, action) => {
  return {
    ...state,
    ItemRepairProfile: action.data,
    Title: 'Edit item',
    IsCreate: false,
    IsOpenFormAddEdit: true
  };
};

const processGetProblemByIdSuccess = (state, action) => {
  return {
    ...state,
    ProblemProfile: action.data,
    Title: 'Edit problem',
    IsCreate: false,
    IsOpenFormAddEdit: true
  };
};

const processAddEditItemError = (state, action) => {
  return {
    ...state,
    ErrorMsg: [action.data.error],
    ItemRepairProfile: {
      ...state.ItemRepairProfile,
      description: action.data.params.description
    }
  };
};

const processSelectListItemTrade = (state, action) => {
  return {
    ...state,
    SelectListItemTrades: action.data
  };
};

const processSelectListItems = (state, action) => {
  return {
    ...state,
    SelectListItem: action.data
  };
};

const processSearchProblem = (state, action) => {
  var result = action.data;

  var manageProject = {
    items: result.data.items,
    params: {
      totalRecord: result.data.totalRecord,
      totalPage: result.data.totalPage,
      skip: result.params.skip + 1,
      take: result.params.take,
      status: result.params.status,
      name: result.params.name,
      sort: { field: result.params.sortField, order: result.params.sortOrder }
    }
  };
  return {
    ...state,
    ManageProblem: manageProject,
    ErrorMsg: [],
    IsOpenFormAddEdit: false
  };
};

const processSelectListItemRepairSuccess = (state, action) => {
  return {
    ...state,
    ItemRepairList: action.data
  };
};

const processSelectListProblemSuccess = (state, action) => {
  return {
    ...state,
    ProblemList: action.data
  };
};



// WEBPACK FOOTER //
// ./src/Items/reducers.js